import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a1274af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ArtworkDetails" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Shadow" }, null, -1))
const _hoisted_3 = { class: "Inner" }
const _hoisted_4 = { class: "Header" }
const _hoisted_5 = { class: "Title" }
const _hoisted_6 = { class: "Suptitle small-caps" }
const _hoisted_7 = { class: "Subtitle small-caps" }
const _hoisted_8 = ["innerHTML"]

import AppService from '@/store/states/AppService'
import type { ArtworkId } from '@/store/states/Artworks'
import useArtwork from './useArtwork'

import {
  DIRECTION as UIBtnSecondaryDirection,
  THEME as UIBtnSecondaryTheme,
} from '@/components/UIBtn/UIBtnSecondary.vue'

interface Props {
  artworkId: ArtworkId
}


import { defineComponent } from 'vue'

const __default__ = defineComponent({})

function setup(__props: any) {

const props = __props as {
  artworkId: ArtworkId
}



const artwork = useArtwork(props.artworkId)

function exit() {
  AppService.send({ type: 'SELECT_ARTWORK', artworkId: null })
}

return (_ctx: any,_cache: any) => {
  const _component_heading = _resolveComponent("heading")!
  const _component_ui_btn_secondary = _resolveComponent("ui-btn-secondary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_heading, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$rt(_unref(artwork).title)), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$rt(_unref(artwork).museum)), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$rt(_unref(artwork).date)) + " — " + _toDisplayString(_ctx.$rt(_unref(artwork).material)), 1)
      ]),
      _createElementVNode("div", {
        class: "Description text",
        innerHTML: _ctx.$rt(_unref(artwork).description)
      }, null, 8, _hoisted_8),
      _createVNode(_component_ui_btn_secondary, {
        direction: _unref(UIBtnSecondaryDirection).BACKWARDS,
        theme: _unref(UIBtnSecondaryTheme).LIGHT,
        onClick: exit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.back_to_museum')), 1)
        ]),
        _: 1
      }, 8, ["direction", "theme"])
    ])
  ]))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    artworkId: null
  },
  setup})